enum VerificaCedibilitaMetodoEnum {
    Otp = "OTP",
    BustaPaga = "BUSTA_PAGA",
}

export default VerificaCedibilitaMetodoEnum;
